import { render, staticRenderFns } from "./Alerts.vue?vue&type=template&id=2a5bf64b&scoped=true"
import script from "./Alerts.vue?vue&type=script&lang=js"
export * from "./Alerts.vue?vue&type=script&lang=js"
import style0 from "./Alerts.scss?vue&type=style&index=0&id=2a5bf64b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5bf64b",
  null
  
)

export default component.exports